import { Tab } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

const SubTabList = ({ listItems, expandedParent = () => {} }) => {
  const [expandedParentIndex, setExpandedParentIndex] = useState(null);

  useEffect(() => {
    expandedParent(expandedParentIndex);
  }, [expandedParentIndex]);

  return (
    <Tab.List className="flex flex-col gap-1 text-body-lg font-medium">
      {listItems.map((item, index) => (
        <Fragment key={index}>
          {item.children ? (
            // Parent Tab with Chevron Toggle
            <div>
              <div
                className={`cursor-pointer flex items-center py-4 ${
                  false
                    ? "text-REELTeal bg-teal-25 border-l-4 border-REELTeal"
                    : "hover:bg-gray-20"
                }`}
                onClick={() =>
                  setExpandedParentIndex(
                    expandedParentIndex === index ? null : index
                  )
                }
              >
                <ChevronDownIcon
                  className={`w-4 h-4 ${
                    expandedParentIndex === index ? "-rotate-180" : ""
                  }`}
                />
                <span className="pl-2">{item.name}</span>
              </div>
              {/* Render Children if Parent is Expanded */}
              {item.children && expandedParentIndex === index && (
                <SubTabList listItems={item.children} />
              )}
            </div>
          ) : (
            // Individual Tab
            <Tab as={Fragment}>
              {({ selected }) => (
                <button
                  className={`block py-1 pr-4 pl-12 text-left text-teal-300 outline-none border-l-4 pl-4${
                    selected
                      ? "text-REELTeal bg-teal-25 border-REELTeal"
                      : item.disabled
                      ? "text-gray-200 cursor-not-allowed border-transparent"
                      : "hover:bg-gray-20 border-transparent"
                  }`}
                >
                  {item.name}
                </button>
              )}
            </Tab>
          )}
          {/* Render Children if Parent is Expanded */}
          {item.children && expandedParentIndex === index && (
            <TabList listItems={item.children} />
          )}
        </Fragment>
      ))}
    </Tab.List>
  );
};

export default SubTabList;
